import { fileViewerAtom } from 'js/file_viewer/core/atoms/atom';
export const volumeAtom = fileViewerAtom(1);
export const mutedAtom = fileViewerAtom(false);
export const volumeStateAtom = fileViewerAtom((get) => {
    const volume = get(volumeAtom);
    const muted = get(mutedAtom);
    return { volume, muted };
});
//# sourceMappingURL=volume.preenvesnextjs.map
